<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <div class="row">
      <div class="col-md-6 col-sm-12 col-lg-6">
        <v-img :src="require('@/assets/img.webp')" class="white--text" />
      </div>
      <div class="col-md-6 col-sm-12 col-lg-6">
        <div class="text-align">
          Ensure the security and integrity of your marine industry database
          with our comprehensive Database Security Audit Service.<br /><br />
          Our team of experienced professionals will conduct a thorough analysis
          of your database to identify any vulnerabilities or weaknesses. We
          will then provide a detailed report with recommendations on how to
          address any issues found, as well as best practices for ongoing
          database security.<br /><br />
          Our Database Security Audit Service is specifically tailored to the
          unique needs of the marine industry, ensuring that your database is
          secure and compliant with industry standards. Protect your valuable
          data and safeguard your business with our expert audit service.
        </div>
      </div>
    </div>
    <div class="row text-primary pl-3 pr-3 pb-3 pt-3">
      <div class="col-md-4 col-sm-12 col-lg-4">
        <v-img
          :src="
            require('@/assets/1902.i039.011.P.m004.c30.cloud services isometric icons-13.jpg')
          "
          class="white--text cls-img"
        />
      </div>
      <div class="col-md-8 col-sm-12 col-lg-8 pl-3 pr-3 pb-3 pt-3">
        <h1>
          <a href="/vulnerability-assessment-for-sql-server"
            >Vulnerability Assessment for SQL Server</a
          >
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "Database Security Audit";
  }
};
</script>
<style scoped>
.text-primary {
  background-color: rgb(215, 215, 215);
}
.text-align {
  text-align: justify;
}
.cls-img {
  width: 50%;
}
h1 {
  font-size: 35px;
}
a {
  text-decoration: none;
  color: black;
}
</style>
